import { httpPlanService } from "@services/HttpService";
import { resolveUrl } from "@utils/UrlUtils";
import { getMSALToken } from "@auth/authUtils";
export async function getPlanOverview({ iata, date }) {
    const params = new URLSearchParams("");
    params.set("iata", iata);
    params.set("date", date);
    const token = await getMSALToken();
    const response = await httpPlanService.get(resolveUrl({
        url: `/get-plan?${params}`,
        mockEndpoint: "/get-plan",
    }), {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}
export async function getProcessStatus({ iata, date, processTypeId, }) {
    const params = new URLSearchParams("");
    params.set("iata", iata);
    params.set("date", date);
    params.set("processTypeId", "" + processTypeId);
    const token = await getMSALToken();
    const response = await httpPlanService.get(resolveUrl({
        url: `/get-process-status?${params}`,
        mockEndpoint: "/get-process-status",
    }), {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}
export async function getPlanMetadata({ iata }) {
    const params = new URLSearchParams("");
    params.set("iata", iata);
    const token = await getMSALToken();
    const response = await httpPlanService.get(resolveUrl({
        url: `/get-metadata?${params}`,
        mockEndpoint: "/get-metadata",
    }), {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}
export async function saveProcessStatuses(body) {
    const token = await getMSALToken();
    const res = await httpPlanService.post(resolveUrl({
        url: `save-process`,
        mockEndpoint: "/save-process",
    }), body, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return res.data;
}
export async function saveRemarks({ body }) {
    const token = await getMSALToken();
    const res = await httpPlanService.post(resolveUrl({
        url: `save-remarks`,
        mockEndpoint: "/save-remarks",
    }), body, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return res;
}
